import { LOAD_USER_INFO, USER_LOGOUT } from "../../constants";
import keycloak from "../../../keycloak";

export const loadUser = () => {
  return async dispatch => {
    try {
      let user = await keycloak.loadUserInfo();
      dispatch({ type: LOAD_USER_INFO, data: user });
    } catch (err) {
      console.log(err);
    }
  };
};

export const logout = () => {
  return dispatch => {
    keycloak.logout();
    return dispatch({ type: USER_LOGOUT });
  };
};
